$(function () {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
    });
    $('a').click(function (event) {
        let scrollOffset = 0;

        if ($(this).is('a[href^="#"]') && $(this).attr('href').length >= 2) {
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top + scrollOffset
            }, 1000);
            return false;
        }
    });
    tabInit();
    // socials-footer
    $('.site-footer__socials ul li').hover(function () {
        $(this).find('a').addClass('active');
        $(this).siblings().find('a').removeClass('active');
    });
    if (screen.width <= 992) {
        $('.site-footer__socials ul li').find('a').removeClass('active');
        $('.site-footer__socials ul li').hover(function () {
            $(this).find('a').removeClass('active');
        });

    }

    // index-slider
    new Swiper('.index-slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

    });
    // menu-responsive
    $('body').on('click', function () {
        $('.mega-menu-site-responsive').removeClass('active');
        $(this).removeClass('overflow-none');
    });

    $('.mega-menu-responsive i').on('click', function (e) {
        e.stopPropagation();
        $('.mega-menu-site-responsive').toggleClass('active');
        $('.mask-shadow').toggleClass('active');
        $('body').toggleClass('overflow-none');
    });

    $('.mega-menu-site-responsive').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().toggleClass('active');
        $(this).siblings('ul').slideToggle(500);
    });

    $('.mega-menu-site-responsive__header').on('click', function (e) {
        e.stopPropagation();
    });

    $('#res-menu-body').on('click', function (e) {
        e.stopPropagation();
    });

    $('.mega-menu-site-responsive__header .close').on('click', function () {
        $('.mega-menu-site-responsive').toggleClass('active');
        $('.mask-shadow').toggleClass('active');
        $('body').toggleClass('overflow-none');
    });

    $('.mask-shadow').on('click', function () {
        $('.mega-menu-site-responsive').toggleClass('active');
        $(this).toggleClass('active');
    });
    $('.mega-menu-site-responsive__body .has-children').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active').find('ul').slideToggle();

    });

    //end-menu-responsive
    // selectize
    $('select:not(".trade-select--download select")').selectize();


    // jalali-date-picker
    kamaDatepicker('date-picker', {buttonsColor: "#0650a3", forceFarsiDigits: true});
    // latest-services__content
    // jscrollpane
    $('.scroll-pane').jScrollPane();
    $(function () {
        $('.scroll-pane').jScrollPane({showArrows: true});
    });

    new Swiper('.site-footer__latests-inset .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.site-footer__top-lates-nav .swiper-next',
            prevEl: '.site-footer__top-lates-nav .swiper-prev',
        },

    });

    // go-top
    $('.site-footer__go-top').click(function (event) {
        let scrollOffset = 0;
        if ($(this).attr('href').length >= 1) {

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top + scrollOffset,
            }, 1000);
            return false;
        }

    });
    $(window).on('scroll', function (e) {
        if ($(window).scrollTop() > 400) {
            $('.site-footer__go-top').addClass('active');
        } else {

            $('.site-footer__go-top').removeClass('active');
        }

    });

    // index-slider
    new Swiper('.index-slider .swiper-container', {
        slidesPerView: 1,
        pagination: {
            el: '.index-slider__pagination .swiper-pagination',
            type: 'bullets',
        },


    });
    // count-down-index
    var time_stamp = $('.collection-index__count-time').attr('data-time');
    var countDownDate = new Date(time_stamp * 1000).getTime(); //to seconds
    let now_day = new Date().getTime();
    let distance_day = countDownDate - now_day;
    let days_day = Math.floor(distance_day / (1000 * 60 * 60 * 24));
    var timers = {};
    timers = setInterval(function () {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        let secondsSplit = sliceCountDown(seconds.toString());
        $('.collection-index__count-last-one').text(secondsSplit.one);
        $('.collection-index__count-last-mouth').text(secondsSplit.mouth);

        let minutesSplit = sliceCountDown(minutes.toString());
        $('.minutes-one').text(minutesSplit.one);
        $('.minutes-mouth').text(minutesSplit.mouth);
        let hoursSplit = sliceCountDown(hours.toString());
        $('.hours-one').text(minutesSplit.one);
        $('.hours-mouth').text(hoursSplit.mouth);


    }, 1000);

    function sliceCountDown(time) {
        let times = {
            mouth: '',
            one: '',
        };
        if (!time.slice(1, 2)) {
            times.mouth = '0';
            times.one = time.slice(0, 1);
        } else {
            times.mouth = time.slice(0, 1);
            times.one = time.slice(1, 2);
        }
        return times;
    }

    // end-count-down-index
    // cat-index-slider
    new Swiper('.cat-index .swiper-container', {
        slidesPerView: 9,
        spaceBetween: 23,
        navigation: {
            nextEl: '.cat-index__navigation .swiper-next',
            prevEl: '.cat-index__navigation .swiper-prev',
        },
        breakpoints: {
            1500: {
                slidesPerView: 9,
                spaceBetween: 23,
            },
            1400: {
                slidesPerView: 7,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 6.9,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 6.5,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 6.2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3.2,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 1.9,
                spaceBetween: 10,

            },
            300: {
                slidesPerView: 1.7,
            }
        }


    });
    //end- cat-index-slider
    // latest-products
    new Swiper('.latest-products-index .swiper-container', {
        slidesPerView: 4,
        spaceBetween: 33,
        navigation: {
            nextEl: '.latest-products-index__navigation .swiper-next-latest-products',
            prevEl: '.latest-products-index__navigation .swiper-prev-latest-products',
        },
        breakpoints: {
            1500: {
                slidesPerView: 4,
                spaceBetween: 33,
            },
            1200: {
                slidesPerView: 3.1,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 5,
            },
            500: {
                slidesPerView: 1.2,
                spaceBetween: 5,

            },
            300: {
                slidesPerView: 1.1,
            }
        }


    });
    // baby-collection
    new Swiper('.baby-collection .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 15,
        navigation: {
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            1500: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            1499: {
                slidesPerView: 1.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 1.9,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 1.9,
                spaceBetween: 15,
            },
            993: {
                slidesPerView: 1.7,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 2.4,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2.3,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 1.2,
                spaceBetween: 5,
            },
            500: {
                slidesPerView: 1.2,
                spaceBetween: 5,

            },
            300: {
                slidesPerView: 1,
                spaceBetween: 2,
            }
        }


    });
    // classic-collection
    new Swiper('.classic-collection .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-next',
        },
        breakpoints: {
            1500: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            1499: {
                slidesPerView: 1.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 1.9,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 1.9,
                spaceBetween: 15,
            },
            993: {
                slidesPerView: 1.7,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 1.2,
                spaceBetween: 5,
            },
            500: {
                slidesPerView: 1.2,
                spaceBetween: 5,

            },
            300: {
                slidesPerView: 1,
                spaceBetween: 2,
            }
        }


    });

    // blog-index
    new Swiper('.index-blog__blogs .swiper-container', {
        slidesPerView: 3,
        direction: 'vertical',
        spaceBetween: 58,
        autoplay: true,
        breakpoints: {
            1500: {
                slidesPerView: 3,
                spaceBetween: 58,
            },
            1499: {
                slidesPerView: 2.9,
                spaceBetween: 20,
            },
            1300: {
                slidesPerView: 2.9,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 2.9,
                spaceBetween: 20,
            },
            993: {
                slidesPerView: 2.7,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 2,
                spaceBetween: 10,

            },
            300: {
                slidesPerView: 2,
                spaceBetween: 10,
            }
        }

    });
    // cpopular-brands
    new Swiper('.popular-brands .swiper-container', {
        slidesPerView: 7,
        spaceBetween: 40,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            1500: {
                slidesPerView: 7,
                spaceBetween: 40,
            },
            1499: {
                slidesPerView: 6.9,
                spaceBetween: 20,
            },
            1300: {
                slidesPerView: 6.9,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4.9,
                spaceBetween: 20,
            },
            993: {
                slidesPerView: 3.7,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 4.5,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3.3,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 2.3,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 2.1,
                spaceBetween: 5,

            },
            300: {
                slidesPerView: 1.7,
                spaceBetween: 5,
            }
        }


    });
    // products-buy
    $('body').on('click', '.agent__map svg', function (e) {
        if (screen.width >= 992) {
            $('.agent__agent-info').addClass('active');
            var target = e.target;
            $(target).addClass('white-back');
            $(target).parents('g').siblings().find('path').removeClass('white-back');
            var offsettop = $(target).offset().top;
            var offsetleft = $(target).offset().left;
            $('.agent__agent-info').css({
                "top": parseInt(offsettop - 50) + "px",
                "left": parseInt(offsetleft + 70) + "px",

            });
            $('.agent__map-city span').html($(target).attr('data-name'));
        } else {
            $('.agent__agent-info').addClass('active');
            var target = e.target;
            $(target).addClass('white-back');
            $(target).parents('g').siblings().find('path').removeClass('white-back');
            $('.agent__map-city span').html($(target).attr('data-name'));
        }


    });

    // scroll-single-blog
    if ($('.scroll-pain').length) {
        window.onscroll = function () {
            myFunction()
        };

        function myFunction() {
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var scrolled = (winScroll / height) * 100;
            document.getElementById("myBar").style.width = scrolled + "%";
        }
    }
    // side-bar-sticky
    if ($('.single-blog').length) {
        var sidebar = new StickySidebar('#sidebar', {
            containerSelector: '.stick_lk',
        });
    }
    if (window.innerWidth < 992) {
        if ($('.single-blog').length) {
            sidebar.destroy();
        }
    }
    // faq-single-blog
    $('.single-blog__faq ul li').on('click', function () {
        $(this).find('.single-blog__faq-slide-items').slideToggle();
        $(this).toggleClass('active');
        $(this).siblings().find('.single-blog__faq-slide-items').slideUp();
        $(this).siblings().removeClass('active');

    });
    if ($('.single-blog__faq ul li')) {
        $('.single-blog__faq ul li').first().addClass('active').slideDown();
        $('.single-blog__faq ul li').first().find('.single-blog__faq-slide-items').slideDown();
    }

    // -----faq-service
    $('.single-blog__faq--service ul li').on('click', function () {
        $(this).find('.single-blog__faq-slide-items--service').slideDown();
        $(this).addClass('active');
        $(this).siblings().find('.single-blog__faq-slide-items--service').slideUp();
        $(this).siblings().removeClass('active');

    });
    if ($('.single-blog__faq--service ul li')) {
        $('.single-blog__faq--service ul li').first().removeClass('active').slideDown();
        $('.single-blog__faq--service ul li').last().addClass('active').slideDown();
        $('.single-blog__faq--service ul li').first().find('.single-blog__faq-slide-items--service').slideUp();
        $('.single-blog__faq--service ul li').last().find('.single-blog__faq-slide-items--service').slideDown();
    }
    // side-titles
    $('.single-blog__article-content a').on('click', function () {
        $('.single-blog__article-content a').removeClass('active');
        $(this).addClass('active');
    });
    // copy-to-clipboard
    $('.single-blog__copy-text').on('click', function () {
        copyToClipboard('.single-blog__page-link')
    });

    function copyToClipboard(element) {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(element).text()).select();
        document.execCommand("copy");
        $temp.remove();
    }

    // our-team
    new Swiper('.about-us__our-teams .swiper-container', {
        slidesPerView: 5,
        spaceBetween: 28,
        breakpoints: {
            1500: {
                slidesPerView: 5,
                spaceBetween: 28,
            },
            1400: {
                slidesPerView: 4.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 4.5,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 4.2,
                spaceBetween: 15,
            },

            992: {
                slidesPerView: 3.6,
                spaceBetween: 15,
            },

            768: {
                slidesPerView: 3.2,
                spaceBetween: 5,
            },
            576: {
                slidesPerView: 2.5,
                spaceBetween: 5,
            },
            500: {
                slidesPerView: 2.2,
                spaceBetween: 5,

            },
            400: {
                slidesPerView: 2.1,
                spaceBetween: 5,

            },
            300: {
                slidesPerView: 1.2,
            }
        }

    });
    // about-awards
    new Swiper('.about-us__awards .swiper-container', {
        slidesPerView: 6,
        spaceBetween: 22,
        breakpoints: {
            1500: {
                slidesPerView: 5,
                spaceBetween: 28,
            },
            1400: {
                slidesPerView: 4.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 4.5,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 4.2,
                spaceBetween: 15,
            },

            992: {
                slidesPerView: 3.6,
                spaceBetween: 15,
            },

            768: {
                slidesPerView: 3.2,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 2.1,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 1.7,
                spaceBetween: 10,

            },
            400: {
                slidesPerView: 1.7,
                spaceBetween: 10,

            },
            300: {
                slidesPerView: 1.2,
            }
        }

    });
    // selectize
    $('select:not(.single-product__pro-color)').selectize();
    // blog-slider
    new Swiper('.blog__slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 36,

    });
    // comments-blog
    new Swiper('.blog__latest-comments-content .swiper-container', {
        slidesPerView: 3,
        direction: 'vertical',
        spaceBetween: 25,
        autoplay: true,

    });
    // lightbox
    const lightbox = GLightbox();
    // single-product__pro-color-render
    var MODELS = [
        {faname: "آبی فیروزه ای", id: "1", color: "blue"},
        {faname: "قرمز", id: "2", color: "red"},
        {faname: "نارنجی", id: "3", color: "orange"},
    ];
    $('.single-product__pro-color').selectize({
        options: MODELS,
        maxItems: 1,
        valueField: 'id',
        searchField: ['faname'],
        placeholder: 'انتخاب کنید',
        render: {
            item: function (item, escape) {
                return "<div class='single-product__color'><span style='background-color: " + escape(item.color) + "'></span><em>" + escape(item.faname) + "</em></div>";
            },
            option: function (item, escape) {
                return "<div class='single-product__color'><span style='background-color: " + escape(item.color) + "'></span><em>" + escape(item.faname) + "</em></div>";
            },
        }
    });

    // end-single-product__pro-color-render
    // single-product-titles
    $('.single-product__content-titles ul li a').on('click', function () {
        $(this).parent().siblings('li').removeClass('active');
        $(this).parent().addClass('active');
    });
    if ($('.single-product__content-titles').length) {
        var offsettop = $('.single-product__content-titles').offset().top;

    }

    $(window).on('scroll', function () {
        var scrolltop = $(window).scrollTop();
        if (scrolltop >= offsettop) {
            $('.single-product__content-titles').addClass('fix-title-content');
        } else {
            $('.single-product__content-titles').removeClass('fix-title-content');
        }
    })
    //end- single-product-titles

    // noUiSlider
    if ($('#range_slider').length) {
        var dragTapSlider = document.getElementById('range_slider');

        noUiSlider.create(dragTapSlider, {
            start: 5,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider2').length) {
        var dragTapSlider = document.getElementById('range_slider2');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range2 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider3').length) {
        var dragTapSlider = document.getElementById('range_slider3');

        noUiSlider.create(dragTapSlider, {
            start: 5,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range3 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider4').length) {
        var dragTapSlider = document.getElementById('range_slider4');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range4 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider5').length) {
        var dragTapSlider = document.getElementById('range_slider5');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range5 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider6').length) {
        var dragTapSlider = document.getElementById('range_slider6');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range6 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider7').length) {
        var dragTapSlider = document.getElementById('range_slider7');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range7 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider8').length) {
        var dragTapSlider = document.getElementById('range_slider8');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range8 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider9').length) {
        var dragTapSlider = document.getElementById('range_slider9');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range9 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider10').length) {
        var dragTapSlider = document.getElementById('range_slider10');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range10 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider11').length) {
        var dragTapSlider = document.getElementById('range_slider11');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range11 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider12').length) {
        var dragTapSlider = document.getElementById('range_slider12');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range12 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider13').length) {
        var dragTapSlider = document.getElementById('range_slider13');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range13 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider14').length) {
        var dragTapSlider = document.getElementById('range_slider14');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range14 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider15').length) {
        var dragTapSlider = document.getElementById('range_slider15');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range15 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider16').length) {
        var dragTapSlider = document.getElementById('range_slider16');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range16 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider17').length) {
        var dragTapSlider = document.getElementById('range_slider17');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range17 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    if ($('#range_slider18').length) {
        var dragTapSlider = document.getElementById('range_slider18');

        noUiSlider.create(dragTapSlider, {
            start: 7,
            connect: 'lower',
            direction: 'rtl',
            step: 1,
            range: {
                'min': 1,
                'max': 10
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.max_range18 span').html(parseInt(values[0]).toFixed(0));
        });
    }
    // delete filters in archive-side
    $('.archive-content__filter-itm i').on('click', function () {
        $(this).parent('.archive-content__filter-itm').remove();
    });
    $('.archive-content__side-dlt-all').on('click', function () {
        $(this).parents('.archive-content__side-filters').find('.archive-content__filter-itms').remove();

    });

    // noUiSlider-price in archive-product
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    if ($('#range_slider_price').length) {
        var dragTapSlider = document.getElementById('range_slider_price');

        noUiSlider.create(dragTapSlider, {
            start: [0, 10000000],
            behaviour: 'drag-tap',
            connect: [true, false, true],
            range: {
                'max': 10000000,
                'min': 0,
            }
        });
        dragTapSlider.noUiSlider.on('update', function (values) {
            $('.min_range-price span').html(numberWithCommas(parseInt(values[0]).toFixed(0)));
            $('.max_range-price span').html(numberWithCommas(parseInt(values[1]).toFixed(0)));
        });
    }
    // search-archive
    $('.archive-content__content-title form .icon-search').on('click', function () {
        $(this).parents('.archive-content__content-title').addClass('active');

    });
    $('.archive-content__content-title form .icon-close').on('click', function () {
        $(this).parents('.archive-content__content-title').removeClass('active');
    });

    // password-panel
    $('.input-panel__input--pass input').on('keyup', function () {
        let $this = $(this);
        let length = $this.val();
        if (length != '') {
            $(this).parent('.input-panel__input--pass').addClass('eye');
        } else {
            $(this).parent('.input-panel__input--pass').removeClass('eye');
        }
    });

    if ($('.input-panel__input--pass').length) {
        $('.input-panel__input--pass i').on('click', function () {
            $(this).parent('.input-panel__input--pass').find('input').toggleClass('hide');
            $(this).toggleClass('line');
        });
    }
    // end-password-panel

    // accordion-legal-information

    $('.panel__legal-information-content .input-panel ').on('click', function (e) {
        e.stopPropagation();
    });

    $('.panel__legal-information').on('click', function () {

        $(this).toggleClass('active');

    });

    // end-accordion-legal-information

    // accordion-faq
    // faq-index
    $('.faq__faq ul li').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active')

    });
    if ($('.faq__faq ul li')) {
        $('.faq__faq ul li').first().addClass('active').slideDown();
        $('.faq__faq ul li').first().find('.faq__faq-slide-items').slideDown();
    }

    // end-accordion-faq

    $('.notfound__content form button').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.notfound__content form').addClass('active');
    })

    if ($('.notfound__left svg').length) {
        $('.notfound__left svg').addClass('load');
    }

    // 404-notfound
    // var i = 8;
    // if ($('.notfound').length) {
    //     setInterval(gohome, 1000);
    // }
    //
    // function gohome() {
    //     i--;
    //     if (i < 0) {
    //         window.location.href = '/';
    //         i = 0;
    //     }
    //
    //     $('.notfound__left-svg em').text(i);
    //
    // }

    // add-count-cart

    $('.plus').on('click', function () {
        var val = parseInt($(this).parent().find('input').val()) + 1;
        $(this).parent().find('input').val(val);
    });

    $('.min').on('click', function () {
        var val = parseInt($(this).parent().find('input').val()) - 1;
        if (val > 0)
            $(this).parent().find('input').val(val);
    });

    // login-inputs
    $(".inputs").keyup(function () {
        if (this.value.length == this.maxLength) {
            $(this).next('.inputs').focus();
        }
    });

    // tabs-in-single-product
    $('.single-product__tab-ttl').on('click', function () {
        $('.single-product__tab-title-responsive').slideToggle();
    });

    $('.single-product__tab-title-responsive li a').on('click', function (e) {
        e.preventDefault();
        let title = $(this).html();
        $('.single-product__tab-ttl').html(title);
        $('.single-product__tab-title-responsive').slideUp();
    });
    // circle-single-product
    var shape = document.getElementById('shape');
    setTimeout(function () {
        shape.setAttribute('stroke-dashoffset', -200 +'px');
    }, 0);

});
/**
 * ticker typing
 * @param {int} [typeSpeed] - Speed of typing.
 * @param {int} [delay] - delay in typing.
 */
$.fn.tickerTyping = function () {
    var typeSpeed = 30,
        delay = 2000,
        $this = $(this),
        $children = $this.children(),
        texts = $children.map(function () {
            return $(this).text();
        }).get();
    var i = 0,
        s = 0;
    var step = function () {
        var $current = $children.eq(i),
            $a = $current.find('a:first');
        $children.hide();
        $current.show();
        $a.text(texts[i].substr(0, s));
        if (s == texts[i].length) {
            s = 0;
            if (i == $children.length - 1) {
                i = 0;
            } else {
                i++;
            }
            setTimeout(step, delay);
        } else {
            setTimeout(step, typeSpeed);
        }
        s++;
    };
    step();
};

/**
 * generate tab
 * @param {string} [tabIndex] - The tabIndex is value of data-tabindex in parent tab.
 */
function tabInit(tabIndex) {
    if (typeof tabIndex === "undefined" || tabIndex === null) {
        $('[data-tabindex]').each(function () {
            let ele = $(this),
                dataTabindex = ele.attr('data-tabindex'),
                hasTrueTab = false;
            ele.find(' .tab-content [data-tabc][data-parent="' + dataTabindex + '"]').hide();
            ele.find(' .tab-title  [data-tab][data-parent="' + dataTabindex + '"]').each(function () {
                let i;
                if ($(this).hasClass('active')) {
                    i = $(this).attr('data-tab');
                    ele.find('.tab-content [data-tabc="' + i + '"][data-parent="' + dataTabindex + '"]').addClass('active').show();
                    hasTrueTab = true;
                }
                if (hasTrueTab !== true) {
                    ele.find('.tab-content [data-tabc="' + i + '"][data-parent="' + dataTabindex + '"]:first-of-type').show();
                    ele.find('.tab-title [data-tab="' + i + '"][data-parent="' + dataTabindex + '"]:first-of-type').addClass('active');
                }
            });
            ele.find(' .tab-title [data-tab][data-parent="' + dataTabindex + '"]').click(function () {
                if (!$(this).hasClass('active')) {
                    let t = $(this).attr('data-tab'),
                        oldActiveTab = ele.find(' .tab-title  [data-tab][data-parent="' + dataTabindex + '"].active').attr('data-tab');
                    ele.find(' .tab-title  [data-tab=' + oldActiveTab + '][data-parent="' + dataTabindex + '"]').removeClass('active');
                    ele.find(' .tab-content  [data-tabc=' + oldActiveTab + '][data-parent="' + dataTabindex + '"]').removeClass('active').hide();
                    $(this).addClass('active');
                    ele.find(' .tab-content  [data-tabc="' + t + '"][data-parent="' + dataTabindex + '"]').show();
                }
            });
        });
    } else {
        let dataTabindex = tabIndex;
        tabIndex = '[data-tabindex=' + tabIndex + ']';
        $(tabIndex).find(' .tab-content [data-tabc][data-parent="' + dataTabindex + '"]').hide();
        $(tabIndex).find(' .tab-title [data-tab][data-parent="' + dataTabindex + '"]').each(function () {
            var i;
            if ($(this).hasClass('active')) {
                i = $(this).attr('data-tab');
                $(tabIndex).find(' .tab-content  [data-tabc="' + i + '"][data-parent="' + dataTabindex + '"]').addClass('active').show();
            }
        });
        $(tabIndex).find(' .tab-title  [data-tab][data-parent="' + dataTabindex + '"]').click(function () {
            if (!$(this).hasClass('active')) {
                let t = $(this).attr('data-tab'),
                    oldActiveTab = $(tabIndex).find(' .tab-title  [data-tab][data-parent="' + dataTabindex + '"].active').attr('data-tab');
                $(tabIndex).find(' .tab-title  [data-tab=' + oldActiveTab + '][data-parent="' + dataTabindex + '"]').removeClass('active');
                $(tabIndex).find(' .tab-content  [data-tabc=' + oldActiveTab + '][data-parent="' + dataTabindex + '"]').removeClass('active').hide();
                $(this).addClass('active');
                $(tabIndex).find(' .tab-content  [data-tabc="' + t + '"][data-parent="' + dataTabindex + '"]').show();
            }
        });
    }
    $('body').on('click', '[data-tabindex-current]', function () {
        let dataTabindex = $(this).attr('data-tabindex-current'),
            ele = $('[data-tabindex="' + dataTabindex + '"]'),
            tabCurrent = $(this).attr('data-tab-current');
        ele.find('.tab-title  [data-tab][data-parent="' + dataTabindex + '"]').removeClass('active');
        ele.find('.tab-content  [data-tabc][data-parent="' + dataTabindex + '"]').hide();
        ele.find('.tab-title  [data-tab="' + tabCurrent + '"][data-parent="' + dataTabindex + '"]').addClass('active');
        ele.find('.tab-content  [data-tabc="' + tabCurrent + '"][data-parent="' + dataTabindex + '"]').fadeIn();
    });
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 *  block loader
 */
function blockLoader(status, element, title) {
    let loaderDom;
    if (typeof status === "undefined" || status === null) {
        status = 'show';
    }
    if (typeof element === "undefined" || element === null) {
        element = 'body';
    }
    if (typeof title === "undefined" || title === null) {
        title = 'در حال بارگذاری ...';
    }
    loaderDom = '<div class="loader-overly"><div class="loader"><div class="spinner"><div></div><div></div><div></div><div></div></div>' + title + '</div>';
    let elementName = element;
    if (typeof element == 'string') {
        element = $(element);
    }
    if (status == 'show') {
        element.append(loaderDom);
        element.find('.loader-overly').show();
        if (elementName == 'body') {
            element.addClass('loader-locked');
            element.find('.loader-overly').addClass('loader-overly_fixed');
        }
    } else {
        element.find('.loader-overly').hide();
        element.find('.loader-overly').remove();
        if (elementName == 'body') {
            element.removeClass('loader-locked');
        }
    }
}

$.fn.extend({
    donetyping: function (callback, timeout) {
        timeout = timeout || 1e3; // 1 second default timeout
        var timeoutReference,
            doneTyping = function (el) {
                if (!timeoutReference) return;
                timeoutReference = null;
                callback.call(el);
            };
        return this.each(function (i, el) {
            var $el = $(el);
            // Chrome Fix (Use keyup over keypress to detect backspace)
            // thank you @palerdot
            $el.is(':input') && $el.on('keyup keypress paste', function (e) {
                // This catches the backspace button in chrome, but also prevents
                // the event from triggering too preemptively. Without this line,
                // using tab/shift+tab will make the focused element fire the callback.
                if (e.type == 'keyup' && e.keyCode != 8) return;

                // Check if timeout has been set. If it has, "reset" the clock and
                // start over again.
                if (timeoutReference) clearTimeout(timeoutReference);
                timeoutReference = setTimeout(function () {
                    // if we made it here, our timeout has elapsed. Fire the
                    // callback
                    doneTyping(el);
                }, timeout);
            }).on('blur', function () {
                // If we can, fire the event since we're leaving the field
                doneTyping(el);
            });
        });
    }
});

/* serialize object */
$.fn.serializeObject = function () {
    "use strict";
    var a = {}, b = function (b, c) {
        var d = a[c.name];
        "undefined" != typeof d && d !== null ? $.isArray(d) ? d.push(c.value) : a[c.name] = [d, c.value] : a[c.name] = c.value
    };
    return $.each(this.serializeArray(), b), a
};
/*
Replace all SVG images with inline SVG */
jQuery('img.svg').each(function () {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);

    }, 'xml');

});

// map
function google_maps() {
    let divs = document.querySelectorAll(".google-map");
    let i = 0;
    if (divs.length) {
        Object.entries(divs).map((object) => {
            i++;
            let lat = parseFloat(object[1].getAttribute('data-lat'));
            let long = parseFloat(object[1].getAttribute('data-long'));
            let myLatLng = {lat: lat, lng: long};
            let data_id = 'googlemap' + i;
            object[1].setAttribute("id", data_id);
            let mapProp = {
                center: new google.maps.LatLng(lat, long),
                zoom: 18,
            };

            let map = new google.maps.Map(document.getElementById(data_id), mapProp);
            let marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                draggable: true,
                animation: google.maps.Animation.DROP,
            });

            function toggleBounce() {
                if (marker.getAnimation() !== null) {
                    marker.setAnimation(null);
                } else {
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                }
            }

        });
    }
}

// say-hello
if (window.console) {
    console.log('%c👋 ivahid Says Hello %civahid is waiting for programmer like you, send resume: %cinfo@ivahid.com', 'color: #ff4342; font-size: 2rem; font-family: Arial; font-weight: bolder', 'color: #454851; font-size: 1.1rem; font-family: Arial;', 'color: #1a9df4; font-size: 1.1rem; font-family: Arial;');
}
const ROOT_CLASS_NAME = "digit-flipper";

class DigitFlipper {
    constructor(element, options = {
        number: 9,
        iterationCount: 9
    }) {

        // First, some parameter sanitizing:
        if (options.number > 9 || options.number < 0) return;

        this.options = Object.assign({}, options);

        if (!this.options.number) this.options.number = 9;
        if (!this.options.iterationCount) this.options.iterationCount = 9;

        // Adjusting the number of iterations,
        // in case our numbers end up in the negatives:
        if (this.options.number - this.options.iterationCount < 0) {
            this.options.iterationCount = this.options.number;
        }

        this.element = element;
        this.digitClassName = `${ROOT_CLASS_NAME}__digit`;
        this.topClassName = `${this.digitClassName}-top`;
        this.bottomClassName = `${this.digitClassName}-bottom`;
        this.flipTopClass = `${this.digitClassName}--flip-top`;
        this.flipBottomClass = `${this.digitClassName}--flip-bottom`;
        this.flipDoneClass = `${this.digitClassName}--flip-done`;
        this.DOMNodes = [];
        this.flipDuration = parseFloat(
            (window.getComputedStyle(document.documentElement).getPropertyValue("--flip-duration") || "1s").replace("s", ""));

        this._init();

        return this;
    }

    _init() {
        this._populateDOM();
    }

    // creates DOM elements for each digit and all of its "iterations"
    _populateDOM() {
        let i = this.options.number - this.options.iterationCount;
        for (i; i <= this.options.number; i++) {
            const digit = document.createElement("span"),
                digitTop = document.createElement("span"),
                digitBottom = document.createElement("span"),
                digitText = document.createTextNode(i);

            digit.className = this.digitClassName;
            digitTop.className = this.topClassName;
            digitBottom.className = this.bottomClassName;

            digitTop.appendChild(digitText);
            digitBottom.appendChild(digitText.cloneNode());
            digit.appendChild(digitTop);
            digit.appendChild(digitBottom);

            this.DOMNodes.push(digit);
            this.element.insertAdjacentElement("afterbegin", digit);
        }
    }

    // runs the animtion sequence for the digit
    flip() {
        this.DOMNodes.forEach((node, index) => {
            const nextNode = this.DOMNodes[index + 1];
            let delay = this.flipDuration * index * 1000;

            // The flipBottomClass turns the bottom half
            // down from it's inital state of 90deg

            // The flipTopClass turns the top half
            // down from it's inital state of 0deg

            const t1 = setTimeout(() => {
                node.classList.add(this.flipBottomClass);
                clearTimeout(t1);
                const t2 = setTimeout(() => {
                    if (nextNode) node.classList.add(this.flipTopClass);
                    clearTimeout(t2);
                    const t3 = setTimeout(() => {
                        node.style.zIndex = index + 1;
                        clearTimeout(t3);
                    }, this.flipDuration);
                }, this.flipDuration);
            }, delay);
        });
    }
}

class FlipCounter {
    constructor(element, value) {
        if (typeof value !== "number") return;

        this.element = element;
        this.targetNumber = value;
        this.targetDigits = [];
        this.numDigits = this.targetNumber.toString().length;
        this.DOMNodes = [];
        this.flipperInstances = [];

        // separate the digits of the value arg
        for (let i = 0; i < this.numDigits; i++) {
            this.targetDigits.push(this.targetNumber.toString()[i]);
        }

        this.populateDOM();
        this.populateInstanceArray();
    }

    // creates wrapper elements for each digit
    populateDOM() {
        this.element.innerHTML = "";

        let i = 0;
        for (i; i < this.numDigits; i++) {
            const container = document.createElement("span");
            container.className = ROOT_CLASS_NAME;

            this.element.appendChild(container);
            this.DOMNodes.push(container);
        }
    }

    // instantiate a DigitFlipper object for each digit
    populateInstanceArray() {
        this.DOMNodes.forEach((digit, index) => {
            this.flipperInstances.push(
                new DigitFlipper(digit, {
                    number: this.targetDigits[index],
                    iterationCount: 4
                }));


        });
    }

    // runs the animation, with a 200ms stagger
    play() {
        this.flipperInstances.forEach((instance, index) => {
            let delay = index * 200;
            setTimeout(() => instance.flip(), delay);
        });
    }
}

// awards-swiper
var awards_swiper = new Swiper('.contact-us__awards .swiper-container', {
    slidesPerView: 5.2,
    spaceBetween: 30,
    breakpoints: {
        1500: {
            slidesPerView: 5.2,
            spaceBetween: 30,
        },
        1400: {
            slidesPerView: 3.7,
            spaceBetween: 15,
        },
        1300: {
            slidesPerView: 3.5,
            spaceBetween: 15,
        },
        1200: {
            slidesPerView: 3.2,
            spaceBetween: 15,
        },

        768: {
            slidesPerView: 3.2,
            spaceBetween: 5,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 5,
        },
        500: {
            slidesPerView: 1.5,
            spaceBetween: 5,

        },
        300: {
            slidesPerView: 1.1,
        }
    }
});
